var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.714 4a.72.72 0 0 0-.508.208A.7.7 0 0 0 10 4.7V6h4V4.7a.7.7 0 0 0-.206-.492.72.72 0 0 0-.508-.208zM16 6V4.7c0-.719-.288-1.406-.798-1.912A2.72 2.72 0 0 0 13.286 2h-2.572c-.717 0-1.406.282-1.916.788A2.7 2.7 0 0 0 8 4.7V6H4a1 1 0 0 0 0 2h1v10.3c0 .719.288 1.406.798 1.912s1.2.788 1.916.788h8.572c.717 0 1.406-.282 1.916-.788S19 19.02 19 18.3V8h1a1 1 0 1 0 0-2zM7 8v10.3c0 .183.073.36.206.492a.72.72 0 0 0 .508.208h8.572a.72.72 0 0 0 .508-.208A.7.7 0 0 0 17 18.3V8z",
  clipRule: "evenodd"
})));
export default SvgIcSDelete;